import { render, staticRenderFns } from "./Chaves.vue?vue&type=template&id=b794a85c"
import script from "./Chaves.vue?vue&type=script&lang=js"
export * from "./Chaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports